// src/context/PatientContext.js
import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";

const PatientDemogarphicContext = createContext();
export const usePatientDemographic = () => useContext(PatientDemogarphicContext);

export const PatientDemographyProvider = ({ children }) => {
  const [patientDemographics, setPatientDemographics] = useState(null);

//   const fetchPatientDemographics = async (patientId) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientDemography?PatientId=${patientId}`
//       );
//       if (!response.ok) throw new Error("Fetch error");

//       const data = await response.json();
//       setPatientDemographics(data);
//     } catch (error) {
//       console.error(error);
//       toast.error("Error occurred while fetching demographic details", {
//         autoClose: 3000,
//       });
//     }
//   };

  return (
    <PatientDemogarphicContext.Provider value={{ patientDemographics, setPatientDemographics }}>
      {children}
    </PatientDemogarphicContext.Provider>
  );
};
